import styles from './error-screen.module.css';

export interface ErrorScreenProps {
  title?: string;
  message: string;
  details?: string;
  onRetry?: () => void;
  onBack: () => void;
}

export function ErrorScreen({ 
  title = 'Failed to Load Story',
  message, 
  details,
  onRetry,
  onBack 
}: ErrorScreenProps) {
  return (
    <div 
      className={styles.errorScreen}
      role="alert"
      aria-labelledby="error-title"
      aria-describedby="error-message"
    >
      <div className={styles.errorIcon} aria-hidden="true">⚠️</div>
      <h1 id="error-title" className={styles.errorTitle}>{title}</h1>
      <p id="error-message" className={styles.errorMessage}>{message}</p>
      
      {details && (
        <div className={styles.errorDetailsContainer}>
          <button 
            className={styles.detailsToggle}
            onClick={(e) => {
              const detailsEl = e.currentTarget.nextElementSibling;
              if (detailsEl) {
                detailsEl.classList.toggle(styles.visible);
              }
            }}
          >
            Show Technical Details
          </button>
          <pre className={styles.errorDetails} aria-live="polite">
            {details}
          </pre>
        </div>
      )}
      
      <div className={styles.errorActions}>
        {onRetry && (
          <button 
            className={styles.retryButton} 
            onClick={onRetry}
            aria-label="Try loading the story again"
          >
            Retry
          </button>
        )}
        <button 
          className={styles.backButton} 
          onClick={onBack}
          aria-label="Return to story selection screen"
        >
          Back to Stories
        </button>
      </div>
    </div>
  );
}

